'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Immutable = require('Immutable');

exports.default = new _Immutable.List(['US/Aleutian', 'US/Alaska', 'US/Arizona', 'US/Hawaii', 'US/Samoa', 'US/Indiana-Starke', 'Canada/East-Saskatchewan']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/timezone-utils/static-2.97/js/lists/TimezoneBlacklist.js
// module id = 468
// module chunks = 0